@if (getRouteValue() !== '/events') {
  <header
    class="min-h-header rounded-b-button-round absolute z-50 flex w-full content-center items-center justify-start bg-white px-6 py-2 align-middle shadow-md">
    @if (getRouteValue() !== '/summary') {
      <img
        alt="back-arrow"
        class="h-[16px] w-[10px]"
        src="../../../../assets/icon-arrow-back.svg"
        (click)="onArrowClick()" />
    }
    <app-header class="flex w-full" [route]="getRouteValue()" [selectedEvent]="eventService.selectedEvent!" />
  </header>
}
